/**
 * /*
 * $Id$
 *
 *  ih.modal, ih.alert, ih.confirm, ih.prompt
 *
 * Create our own custom alert, confirm, and prompt modals to replace
 * the native window methods of the same names.
 *
 * They all create instances of the base class ih.modal which can also be used
 * to create other customized modals like a 3 way choice, a message with no buttons, etc.
 *
 * These are "modals" in that the rest of the page is "disabled" while they're open.
 * We'll use css to have the modal cover the page and disable scrolling on body to accomplish this.
 * The "mask" element is no longer necessary to enforce modal context.
 * It acts as more of an optional custom background backdrop for the modal.
 *
 * Note that when these are called they don't pause the execution of other scripts
 * and/or rendering the way that the native window versions do.
 * Instead, we define our own callback functions.
 *
 * ih.modal, ih.alert, ih.confirm, and ih.prompt are meant to be singletons.
 * They create themselves upon instantiation and destroy themselves on close.
 * Technically there can be multiple instances existing concurrently, but
 * only one modal will ever be open at any given time for each namespaced queue.
 * Modals that are instantiated while a modal is already open go into the queue.
 * After the current modal closes, the next modal in that queue automatically opens.
 *
 * ih.modalQueue is an object that stores namespaced arrays of modals waiting to open
 * ih.modalQueue[namespace] = new Array()
 * ih.modalQueue[namespace].currentModal stores a reference to the currently open modal in that queue or is undefined.
 * ih.currentModal stores a reference to the currently open modal (the last one to open regardless of namespace) or is undefined.
 *
 * TODO: keyboard events? esc key? emulate native keyboard commands where applicable
 * TODO: implement topZindex so that we always position on top? or just let css handle it?
 *
 *  Depends:
 *      jQuery
 *      _modals.css
 *
 *
 * Usage:
 *
 * ih.alert("This is an alert modal");
 *
 * ih.alert("This is an alert message with an optional callback that triggers when you close it", function() {
 *      console.log("ih.alert callback");
 * });
 *
 * ih.errorAlert("I am a special preconfigured alert to show errors! I have the title 'Oops!' and the special extra css class of 'ih_modal_error_alert'");
 *
 *     // ajax example:
 *     $.post("/some/ajax/action/url", { param: val, ... }, function( json ) {
 *          if ( ! json.success ) {
 *              ih.error_alert(json.message, function() {
 *                  // reset the UI
 *              });
 *          }
 *      });
 *
 *
 * // callback has one param set true if confirmed, false if canceled.
 * ih.confirm("This is a confirm modal", function( confirm ) {
 *      if ( confirm ) {
 *          // do something
 *      }
 *      else {
 *          // do something else
 *      }
 * });
 *
 *
 * // callback has one param set to string value of input if confirmed, false if canceled
 * ih.prompt("This is a prompt message", function( value ) {
 *      if ( value ) {
 *          // do something with the user input value
 *      }
 *      else {
 *          // do something else
 *      }
 * });
 *
 * @format
 */

var ih = ih || {};

(function ($) {
    //console.log("loading modal classes!");

    // Stores pending modal instances. You can have multiple namespaced queues.
    // The default queue namespace is "general".
    //
    // We also setup a "priority" namespace to represent the highest z-index level available.
    // These should always be on top - things like confirmation dialogs or alerts
    // that you may want to pop open while another modal is open.
    //
    // You can also setup your own namespaces, but if you want to control it's z-indexing relative
    // to the other namespaces, you will need to add css for it.
    ih.modalQueue = {
        general: new Array(),
        priority: new Array(),
        //...
    };
    ih.currentModal = undefined; // stores the currently open modal instances in the general namespace (if any) or empty

    ih.modal = function (options) {
        var _this = this; // class instance
        var _isOpen = false;
        var _autoCloseTimer;
        var _value = false;
        var _hasChanges = false; // if any form input values changed since opening
        var _formSubmitOk = false;
        var _defaultFormSubmit = false; // false if a custom submit callback is used

        var _default_settings = {
            container: "body", // the element that modal is appended to
            queue: "general", // namespace of the queue to add this modal to

            cssClass: false, // string extra css classes to add to modal in addition to "ih-modal" or false
            mask: true, // opens a mask (backdrop) behind the modal for styling. Note that this is purely cosmetic.

            title: false, // string value or false
            message: false, // string value: REQUIRED (usually)

            form: false, // whether or not this is a modal form. false or object - see default_form below

            clickOutToClose: false, // close if clicking outside of the modal dialog
            closeButton: true, // whether or not to include the close X button.
            closeButtonConfirm: false, // when using the close X button to close, if there is a form with unsaved changes, let them choose confirm or cancel
            autoClose: false, // false or number of seconds for how long to wait before autoClosing
            replaceCurrent: false, // if there's a currently opened modal, close it and open this modal in its place ahead of any other modals in the queue
            buttons: {}, // hash of buttons objects to include in footer

            // callbacks
            beforeOpen: function () {}, // not used yet
            open: function () {},
            beforeClose: function () {
                // return false from within this to prevent the modal from closing
                return true;
            },
            close: function () {},
        }; // end default_settings

        var _default_form = {
            name: false, // optional
            action: false, // optional
            method: "post", // string get|post
            fields: false, // include multiple fields in object notation, or a jquery wrapped chunk of html with your fields
            focusFirstField: true, // when opening the modal, set focus on the first field
            valueOnSingularField: true, //Will only send the value when there is a single field with a value

            // when posting these properties are populated
            params: false, // serialized form inputs
            hasChanges: false, // true if any of the form input values have changed

            // -------------------------------------------------------------------------------------------------
            // Defining Callbacks:
            // -------------------------------------------------------------------------------------------------

            // This gets called when submitting the form instead of the beforeClose callback.
            // You can define your own custom function.
            // Returning false will prevent the form from closing.
            //
            // If you need to wait for an ajax request to resolve before closing the form,
            // you will need to call form.ok() from the ajax callback
            submit: function (params, form) {
                // console.log("default submit callback");
                _defaultFormSubmit = true;

                // if a form action is provided, we make an ajax request to "submit" the form.
                if (form.action) {
                    // TODO: use option for method: get/post
                    $.post(form.action, params, null, "json")
                        .done(function (response) {
                            if (response.success) {
                                form.success(response, form);
                                form.ok();
                            } else {
                                form.failure(response, form);
                                form.element.removeClass("posting");

                                // handle recaptcha stuff. Find the actual form object, and pass that to the formFailed function
                                if (_settings.use_captcha) {
                                    var $formObject = $(form.element[0]);

                                    ih.form.reCaptcha.formFailed($formObject);
                                }
                            }
                            form.updateFields(response.success);
                        })
                        .fail(function (jqXHR, textStatus) {
                            ih.errorAlert(
                                "Something went wrong: " +
                                    textStatus +
                                    ". Please contact Customer Service.",
                                function () {
                                    form.element.removeClass("posting");
                                },
                                {
                                    queue: "priority",
                                }
                            );
                        });
                    // prevent the modal from closing
                    return false;
                }

                // allows the modal to close
                return true;
            },

            // This gets called as the success case callback from the submit callback above.
            // e.g. when the ajax response.success = true
            success: function (response, form) {
                //console.log("default success - ", response);

                if (response.tracking_events) {
                    for (var index in response.tracking_events) {
                        $(document).trigger(
                            "trackingEvent",
                            response.tracking_events[index]
                        );
                    }
                }
                if (response.message) {
                    ih.success(response.message);
                }
            },

            // This gets called as the failure case callback from the submit callback above.
            // e.g. when the ajax response.success = false
            // Note that in both of these success and failure cases we receive a response back from the server.
            // i.e. This does NOT get called for a missing/bad server response.
            failure: function (response, form) {
                //console.log("default failure!", response);

                if (response.tracking_events) {
                    for (var index in response.tracking_events) {
                        $(document).trigger(
                            "trackingEvent",
                            response.tracking_events[index]
                        );
                    }
                }

                ih.error(response.message, { autoClose: 2 });
                if (response.form && response.form.errors) {
                    form.errors(response.form.errors);
                }
                $(".ih-has-error").first().focus();
            },

            // =============================================================================
            // Don't redefine either of these unless you know what you're doing!
            // =============================================================================

            // This gets called from the submit callback to close
            // the modal form after a successful submission.
            // If coding your own submit callback function, you will need
            // to include a call to this to close the modal.
            ok: function () {
                _formSubmitOk = true;
                _this.close("confirm");
            },
            // Takes an array of error objects (usually from an ajax response)
            // and updates the form UI with the appropriate validation errors
            errors: function (errors) {
                _formSubmitOk = false;

                // check if form.fields is just a jquery wrapped html blob.
                if (
                    Object.prototype.toString.call(_settings.form.fields) !==
                    "[object Array]"
                ) {
                    //if ( form.fields instanceof jQuery ) {
                    $(errors).each(function () {
                        var $input = $form.find("[name='" + this.name + "']");
                        if ($input.length) {
                            ih.form.validateInput(
                                $input[0],
                                false,
                                this.message
                            );
                        }
                    });
                }
                // else it's an array of vanilla js field objects
                else {
                    $.each(form.fields, function () {
                        var $input = $form.find("[name='" + this.name + "']");
                        if (!$input.length) {
                            return;
                        }
                        for (var i in errors) {
                            if (errors[i].name == this.name) {
                                ih.form.validateInput(
                                    $input[0],
                                    false,
                                    errors[i].message
                                );
                                return;
                            }
                        }
                        ih.form.validateInput($input[0], true);
                    });
                }
            },

            // Tries to call an `update` function if it exists for a field.
            // It's run after each time form's sent.
            // A `success` value from a response will be passed to the field's function.
            updateFields: function (success) {
                if (
                    Object.prototype.toString.call(_settings.form.fields) ===
                    "[object Array]"
                ) {
                    $.each(form.fields, function () {
                        if (this.update && $.isFunction(this.update)) {
                            this.update(success);
                        }
                    });
                }
            },
        }; // end definition of default form

        var _settings = $.extend(_default_settings, options);
        if (_settings.form) {
            var form = $.extend(_default_form, _settings.form);
            _settings.form = form;
        }

        var _beforeCallbacks = {
            open: function () {
                _settings.beforeOpen();
            },
            close: function () {
                return _settings.beforeClose();
            },
        };
        var _callbacks = {
            open: function () {
                _settings.open();
            },
            close: function () {
                _settings.close();
            },
        };

        //if ( ! _settings.message ) {
        //alert("You must provide a message!");
        //return false;
        //}

        // queue setup
        var _queue = _settings.queue;
        if (ih.modalQueue[_queue] == undefined) {
            ih.modalQueue[_queue] = new Array();
            ih.modalQueue[_queue].currentModal = undefined;
        }
        var queueCssClass = "ih-modal-queue-" + _queue;

        // build the DOM
        var $modal = $(templates.modal).addClass(queueCssClass),
            $dialog = $modal.find(".ih-modal-dialog"),
            $content = $modal.find(".ih-modal-content"),
            $header,
            $body = $modal.find(".ih-modal-body"),
            $message = $modal.find(".ih-modal-message"),
            $form = function () {},
            $formContent = $(ih.form.templates.formContent),
            $input = function () {},
            $fields = "no fields",
            $footer,
            $closeButton,
            $mask = $(templates.mask).addClass(queueCssClass);

        if (_settings.cssClass) {
            $modal.addClass(_settings.cssClass);
        }

        if (_settings.form && _settings.form.fields) {
            $form = $(ih.form.templates.form).prop("noValidate", true);
            _settings.form.element = $form;

            // TODO: come up with a scheme to guarantee form name uniqueness;
            var formName = _settings.form.name ? _settings.form.name : "form1";
            $form.attr("name", formName); // need to ensure this is unique

            var formAction = _settings.form.action
                ? _settings.form.action
                : "_self";
            $form.attr("action", formAction);

            var formMethod = _settings.form.method
                ? _settings.form.method
                : "post";
            $form.attr("method", formMethod);

            $form
                .on("submit", function (e) {
                    //console.log("form submit event!");

                    e.preventDefault();

                    // if already posting, do nothing.
                    if ($form.is(".posting")) {
                        //console.log("form is already posting. bail!");
                        return false;
                    }

                    // first run any client-side validation. If it passes
                    if (ih.form.validate($form[0])) {
                        $modal
                            .find(".ih-modal-button-primary")
                            .first()
                            .trigger("click");
                    } else {
                        console.error("client-side validation failed!");
                    }
                })
                .replaceAll($content);

            // recache
            $body = $modal.find(".ih-modal-body");
            $message = $modal.find(".ih-modal-message");

            // for simple cases, we expect an array of objects representing our fields.
            if (
                Object.prototype.toString.call(_settings.form.fields) ===
                "[object Array]"
            ) {
                ih.form.builder.buildFormFields(
                    _settings.form.fields,
                    $formContent,
                    formName
                );
            }
            // or else we're getting a chunk of html containing the inputs we want mixed in with whatever else.
            else {
                $formContent.append(_settings.form.fields);
            }
            $formContent.insertAfter($message);

            // if there are any select boxes and we have the selectbox plugin installed, initialize them
            if ($.fn.selectbox !== undefined) {
                $form.find("select").selectbox({ cssClass: "ih-select" });
            }

            if (_settings.use_captcha) {
                // console.log("Rendering recaptcha form:", $form);
                ih.form.reCaptcha.render($form);
            }

            // keep track of if any field values change
            // and run client side validation on any field whose value changes
            $form.on("change", "input, select, textarea", function (e) {
                _hasChanges = true;
                ih.form.validateInput(this);
            });

            // don't use the blur event to fire validation checks until the form has been interacted with.
            // this way, validation won't fire in the case of opening and then immediately closing a form
            $form.on("click keyup", "input, select, textarea", function (e) {
                // exception is when tabbing out of the first input that gets focused by default
                if (e.keyCode == 9) {
                    // for some reason "this" gets overwritten with the next input
                    // instead of the input we just blurred off of. So be explicit.
                    var firstField = $form.find("input, select, textarea")[0];
                    ih.form.validateInput(firstField);
                }

                $form.on("blur", "input, select, textarea", function () {
                    //console.log("blur event!");
                    ih.form.validateInput(this);
                });
            });
        }

        if (_settings.message) {
            $message.html(_settings.message);
        }

        // if there are buttons, build the footer
        if (!$.isEmptyObject(_settings.buttons)) {
            $footer = $(templates.footer);

            var footerRequired = false;

            // create a button for each one
            $.each(_settings.buttons, function (index) {
                if (this.preBaked) {
                    // if a form submit callback is provided, use it instead of the confirm button's beforeCallback.
                    if (
                        _settings.form &&
                        _settings.form.submit &&
                        $.isFunction(_settings.form.submit)
                    ) {
                        _beforeCallbacks["confirm"] = function (params, form) {
                            return _settings.form.submit(params, form);
                        };
                    }
                } else {
                    footerRequired = true;

                    var $button = $(templates.button).data(
                        "ih-modal-action",
                        index
                    );

                    if (this.label != undefined)
                        $button.children("span").text(this.label);
                    if (this.cssClass != undefined)
                        $button.addClass(this.cssClass);
                    if (this.id != undefined) $button.attr("id", this.id);

                    if (
                        this.beforeCallback != undefined &&
                        $.isFunction(this.beforeCallback)
                    ) {
                        // add to beforeCallbacks hash, indexed by the button key.
                        // we'll bind button events later...
                        _beforeCallbacks[index] = this.beforeCallback;
                    } else {
                        _beforeCallbacks[index] = function () {
                            return true;
                        };
                    }

                    if (
                        this.callback != undefined &&
                        $.isFunction(this.callback)
                    ) {
                        // add to callbacks hash, indexed by the button key.
                        // we'll bind button events later...
                        _callbacks[index] = this.callback;
                    }

                    // Setups for the 'confirm' button - add callbacks if there
                    if (index == "confirm") {
                        // The existence of an input or a button element with type "submit"
                        // enables the browser functionality of hitting the enter key to submit the form
                        $button.attr("type", "submit");

                        // if a form submit function is provided, use it instead of the confirm button's beforeCallback.
                        if (
                            _settings.form &&
                            _settings.form.submit &&
                            $.isFunction(_settings.form.submit)
                        ) {
                            _beforeCallbacks["confirm"] = function (
                                params,
                                form
                            ) {
                                // call the submit function
                                return _settings.form.submit(params, form);
                            };
                        } // end form.submit test
                    } // this is the confirm button (i.e. Ok)

                    $button.appendTo($footer);
                } // end else not prebaked function
            });

            if (footerRequired) {
                $footer.insertAfter($body);
            }
        } // end if there are buttons to define

        // if there's a title/header area, the close button gets appended to it
        if (_settings.title) {
            $header = $(templates.header);
            $header.children(".ih-modal-title").html(_settings.title);
            $header.insertBefore($body);

            // add an extra class to the parent div that we can use for alternative styling
            $modal.addClass("with-title");
        }

        if (_settings.tapTarget) {
            _callbacks["tapTarget"] = _settings.tapTargetCallback;

            // the original element we are showcasing
            var $elem = $(_settings.tapTarget);

            if (!$elem.length) {
                console.error(
                    "tapTarget element could not be found",
                    _settings.tapTarget
                );

                _this = false;
                return _this;
            }

            var pos = $elem.offset();
            var scrollTop = $(document).scrollTop();

            // for now, force scrollTop back to 0.
            if (scrollTop !== 0) {
                $(document).scrollTop(0);
                scrollTop = 0;
            }

            var w = $elem.outerWidth();
            var h = $elem.outerHeight();

            //console.log("offset:", pos, "width", w, "height", h);

            var pageW = $("body").outerWidth();
            var isRight = pos.left > pageW / 2;
            var isMiddle = pos.top - scrollTop + h > 88;

            // is this at the top or in the middle of the page?
            if (isMiddle) {
                //console.log("Middle of the page");
                $modal.addClass("is-middle");
            } else {
                //console.log("Top of the page");
            }

            // is this anchored to the left or the right hand side?
            if (isRight) {
                //console.log("Right aligned!!");
                $modal.addClass("is-right");
            } else {
                //console.log("Left aligned");
            }

            var $tapTargetPlaceholder = $(templates.tapTarget)
                .css({
                    height: h / 2 + 44,
                })
                .prependTo($content);

            // helper is a clone of the original element but absolutely positioned
            // (and sometimes styled differently)
            var $helper = $tapTargetPlaceholder
                .find(".ih-modal-tap-target-helper")
                .css({
                    width: w,
                    height: h,
                    left: isRight ? "auto" : pos.left,
                    right: isRight ? pageW - (pos.left + w) : "auto",
                });
            $elem.clone().appendTo($helper);

            var $center = $tapTargetPlaceholder
                .find(".ih-modal-tap-target-centerpoint")
                .css({
                    left: isRight ? "auto" : pos.left + w / 2,
                    right: isRight ? pageW - (pos.left + w) + w / 2 : "auto",
                    top: h / 2,
                });

            // clicking on the tap target will simulate a click on the original element
            var $tapTarget = $tapTargetPlaceholder.find(".ih-modal-tap-target");
            $tapTarget.on("click", function (e) {
                //console.log("simulate click!", $elem, e);
                //$elem.trigger("click", e);
                // trigger native click event on element which allows href to be followed.
                $elem[0].click();

                _this.close("tapTarget");

                return false;
            });

            /* these lines were commented out to prevent the feature tip positioning
             * to be off when a user scrolls at the time of the feature tip firing */

            // var top = pos.top - scrollTop;
            // $dialog.css({ top: top });

            //var $tapTargetCircle = $( templates.tapTarget ).prependTo( $content );
        } // end if tapTarget

        // if there's a close button, attach it to the header, or else the modal body
        if (_settings.closeButton) {
            $closeButton = $(templates.closeButton)
                .data("ih-modal-action", "close")
                .appendTo(_settings.title ? $header : $body);
        }

        // public properties (are these being used?)
        //this.form = $form;
        //this.input = $input;

        // public getter functions
        this.isOpen = function () {
            return _isOpen;
        };
        this.queue = function () {
            return _queue;
        };

        // Function to open the modal
        this.open = function () {
            // open if this is the only modal
            // otherwise wait until the previous ones are closed
            // (their close callback will trigger the next one in line to open)
            if (!ih.modalQueue[_queue].currentModal) {
                _isOpen = true;

                // if there is a mask (backdrop), add it
                if (_settings.mask) {
                    // if there's already a mask on the page (for this queue), use it instead of creating a new one.
                    if ($(".ih-modal-mask." + queueCssClass).length) {
                        $mask = $(".ih-modal-mask." + queueCssClass).first();
                    }
                    // else use the one we've prepped
                    else {
                        $mask.appendTo(_settings.container);
                    }
                }
                // if no mask is specified
                else {
                    // if there's already a mask on the page from the last modal, remove it
                    if ($(".ih-modal-mask." + queueCssClass).length) {
                        $mask = $(".ih-modal-mask." + queueCssClass).remove();
                    }
                }

                // disable scrolling on body
                $("body").addClass("has-open-modal");

                // clickOutToClose - set to close the modal when clicking outsdie?
                if (_settings.clickOutToClose) {
                    $modal.on("click", function (e) {
                        if ($(e.target).is(".ih-modal")) {
                            _this.close("close");
                        }
                    });
                }

                // handler for button clicks - ok, cancel and the close X
                $modal.on(
                    "click",
                    ".ih-modal-button, .ih-modal-close-x",
                    function (e) {
                        e.preventDefault();

                        var action = $(this).data("ih-modal-action");

                        if (options.use_captcha && "confirm" == action) {
                            // need to find my captcha div...
                            var captcha_form = $(this).closest("form");
                            var captcha_div = captcha_form.find(
                                ".recaptcha_field > div"
                            )[0];

                            ih.form.reCaptcha.execute(
                                captcha_form,
                                _this.close
                            );
                        } else {
                            _this.close(action);
                        }
                    }
                );

                // add the newly defined modal to the document
                $modal.appendTo(_settings.container); //.addClass("open");

                // timeout of any duration allows the css transition to render correctly.
                setTimeout(function () {
                    $mask.addClass("open");
                    $modal.addClass("open");
                }, 1);

                if (_settings.form && _settings.form.fields) {
                    $formContent.trigger("ih-form-rendered");
                }

                // set the focus after the open animation
                setTimeout(function () {
                    // if there's a form, focus the input
                    if (_settings.focus) {
                        $modal.find(_settings.focus).focus();
                    } else if (_settings.form && _settings.form.fields) {
                        if (_settings.form.focusFirstField) {
                            $form
                                .find("input, textarea, select")
                                .first()
                                .focus();
                        } else {
                            // don't focus anything...
                        }
                    }
                    // else on the primary button
                    else {
                        $modal.find(".ih-modal-button-primary").focus();
                    }
                }, 500);

                // store global references to this instance
                ih.modalQueue[_queue].currentModal = _this;
                if (_queue == "general") {
                    ih.currentModal = _this;
                }

                // fire open callback if there is one
                _settings.open();

                if (_settings.autoClose) {
                    _autoCloseTimer = setTimeout(function () {
                        //_this.beforeClose("close");
                        _this.close("close");
                    }, parseInt(_settings.autoClose) * 1000);
                }
            }
            // else there's already a modal open, add this to the queue
            else {
                // front of the line
                if (_settings.replaceCurrent) {
                    ih.modalQueue[_queue].unshift(_this);
                    ih.modalQueue[_queue].currentModal.close();
                }
                // end of the line
                else {
                    ih.modalQueue[_queue].push(_this);
                }
            }
        }; // end function open

        // Close function - called via button click handler with action indicating which button was clicked.
        this.close = function (action) {
            var modal = this;

            // if there is no action, that means the X button was called - make that close
            if (action == undefined) action = "close";

            var okToClose = true; // assume for now

            // trigger the beforeCallback
            // note that if it returns false, the close is canceled and the main callback is not fired.
            // special case: if closing a form with changes via the close x, pop open a confirm dialog
            // to let them choose if they meant to submit or cancel their changes.
            if (
                action == "close" &&
                _settings.form &&
                _hasChanges &&
                _settings.closeButtonConfirm
            ) {
                okToClose = false;
                ih.confirm(
                    "You made changes to this form. Did you want to submit them?",
                    function (yes) {
                        if (yes) {
                            modal.close("confirm");

                            // If they fail validation attempt to close again via the close button,
                            // don't confirm again unless they've made additional changes
                            _hasChanges = false;
                        } else {
                            modal.close("cancel");
                        }
                    },
                    {
                        queue: "priority",
                    }
                );
            }
            // if finished posting a form and everything is OK
            else if (action == "confirm" && _settings.form && _formSubmitOk) {
                okToClose = true;
            }
            // normal case: we want to close, but need to handle beforeCallbacks (there should at least be the default)
            else if (
                _beforeCallbacks[action] &&
                $.isFunction(_beforeCallbacks[action])
            ) {
                // if posting a form
                if (_settings.form && action == "confirm") {
                    // make sure not to post if already posting
                    if ($form.is(".posting")) {
                        return false;
                    }

                    // serialize the form values
                    // if it's a simple, single input form like ih.prompt(),
                    // just grab the first value and send it, or else we'll send the entire serialized array of input names/values
                    var values = $form.serializeArray();
                    if (values.length) {
                        // single input form / prompt
                        if (
                            values.length == 1 &&
                            _settings.form.valueOnSingularField
                        ) {
                            _value = values[0].value;
                        } else {
                            _value = values;
                        }
                    } else {
                        console.error("there aren't any form field values!!");
                        _value = false;
                    }

                    // Make the form look like it's locked down while it posts
                    $form.addClass("posting");

                    var form = _settings.form;
                    form.params = _value;
                    form.hasChanges = _hasChanges;

                    // the beforecallback for 'confirm' does the actual post.
                    okToClose = _beforeCallbacks["confirm"](_value, form);
                } else {
                    okToClose = _beforeCallbacks[action]();
                }

                if (okToClose == undefined) {
                    //console.log("okToClose is undefined");
                    okToClose = true;
                }
            }

            if (okToClose) {
                // remove from global
                ih.modalQueue[_queue].currentModal = undefined;
                if (_queue == "general") {
                    ih.currentModal = undefined;
                }

                if (_settings.autoClose) {
                    clearTimeout(_autoCloseTimer);
                }

                // if there's another modal pending, leave this stuff around for a more seamless UI
                if (!ih.modalQueue[_queue].length) {
                    // re-enable scrolling on body
                    $("body").removeClass("has-open-modal");
                    // remove blur effect
                    $("body").removeClass("ih-blur-content");

                    // close mask and remove it
                    if (_settings.mask) {
                        $mask.removeClass("open");
                        setTimeout(function () {
                            $mask.remove();
                        }, 500);
                    }
                }

                // unbind modal events, close and remove from DOM
                $modal.off().removeClass("open");
                setTimeout(function () {
                    $modal.remove();
                }, 500);

                // fire callbacks after animation is done
                setTimeout(function () {
                    if (
                        _callbacks[action] &&
                        $.isFunction(_callbacks[action])
                    ) {
                        // if there's a form, we need to supply an argument with the input value
                        if (_settings.form && action == "confirm") {
                            //console.log("_value", _value);
                            //console.log("_hasChanges", _hasChanges);

                            var form = {
                                params: _value,
                                hasChanges: _hasChanges,
                            };
                            _callbacks[action](_value, form);
                        } else {
                            _callbacks[action]();
                        }
                    }

                    // lastly check the modal queue and open the next modal if there is one
                    if (ih.modalQueue[_queue].length) {
                        //console.log("found another modal in the queue. Opening it!");
                        var next_modal = ih.modalQueue[_queue].shift();
                        next_modal.open();
                    }
                }, 500);
            }
            // not okay to close.
            else {
                // if submit button has focus, blur it
                $("button:focus").blur();

                // make form look editable again
                // note that if is there is a form with an action the .posting class is handled differently, since we're
                // waiting for an ajax request to resolve.

                // TODO: if there is a custom submit function uses ajax, the posting class is not handled correctly yet.
                // Currently it gets removed right away instead of waiting for the response from the request.
                if (
                    !form ||
                    !_defaultFormSubmit ||
                    (form && _defaultFormSubmit && !form.action)
                ) {
                    $form.removeClass("posting");
                }
            }
        }; // end function close

        // ==========================================================================================
        // completely defined, open the modal
        // ==========================================================================================
        this.open();

        return this;
    }; // end ih.modal()

    ih.alert = function (message, callback, options) {
        var callback =
            callback && $.isFunction(callback) ? callback : function () {};
        var _default_settings = {
            message: message,
            buttons: {
                ok: {
                    label: "OK",
                    cssClass: "ih-modal-button-primary",
                    callback: callback,
                },
            },
            close: callback,
        };
        var _settings = $.extend(true, _default_settings, options);
        return new ih.modal(_settings);
    };

    // Special preconfigured alert for errors
    ih.alertError = ih.errorAlert = function (message, callback, options) {
        var _default_settings = {
            title: "Oops!",
            cssClass: "ih-modal-alert-error",
        };
        var _settings = $.extend(true, _default_settings, options);
        return new ih.alert(message, callback, _settings);
    };

    // --------------------------------------------------------------------------------------------------------
    // Confirm function
    ih.confirm = function (message, callback, options) {
        var callback =
            callback && $.isFunction(callback) ? callback : function () {};
        var beforeCallback =
            options && options.beforeClose && $.isFunction(options.beforeClose)
                ? options.beforeClose
                : function () {
                      return true;
                  };
        var _default_settings = {
            message: message,
            buttons: {
                cancel: {
                    label: "Cancel",
                    cssClass: "ih-modal-button-cancel",
                    callback: function () {
                        callback(false);
                    },
                    beforeCallback: function () {
                        return beforeCallback(false);
                    },
                },
                confirm: {
                    label: "OK",
                    cssClass: "ih-modal-button-primary",
                    callback: function () {
                        callback(true);
                    },
                    beforeCallback: function () {
                        return beforeCallback(true);
                    },
                },
            },
            close: function () {
                callback(false);
            },
        };
        var _settings = $.extend(true, _default_settings, options);
        _settings.beforeClose = function () {
            return beforeCallback(false);
        };

        return new ih.modal(_settings);
    };

    // --------------------------------------------------------------------------------------------------------
    // Special preconfigured confirmation for deleting stuff
    ih.confirmDelete = ih.deleteConfirm = function (
        message,
        callback,
        options
    ) {
        var _default_settings = {
            title: "Are You Sure?",
            cssClass: "ih-modal-confirm-delete",
            buttons: {
                confirm: { label: "Delete" },
            },
        };
        var _settings = $.extend(true, _default_settings, options);
        return new ih.confirm(message, callback, _settings);
    };

    // --------------------------------------------------------------------------------------------------------
    // This shows a modal spinner with a message blocking further action until it is removed.
    // It will need to be closed programmatically.
    // 1. use an instance variable:
    // var loading_spinner = ih.spinner("Loading&hellip;");
    // loading_spinner.close();
    //
    // 2. use the global instance for the current open modal
    // ih.currentModal.close();
    //
    // 3. use the replaceCurrent option on the next modal you want to open
    // ih.flash("Done!", null, { replaceCurrent: true });
    ih.spinner = function (message, callback, options) {
        var callback =
            callback && $.isFunction(callback) ? callback : function () {};
        var _default_settings = {
            cssClass: "ih-modal-spinner",
            message:
                '<span class="ih-modal-spinner-icon ih-anim-spin infinite"></span> ' +
                message,
            autoClose: false,
            buttons: {},
            closeButton: false,
            close: callback,
        };
        var _settings = $.extend(true, _default_settings, options);
        return new ih.modal(_settings);
    };

    // --------------------------------------------------------------------------------------------------------
    // This flashes a modal green message with a checkmark for when an action is complete
    // The message auto-closes after 2 seconds.
    ih.flash = function (message, callback, options) {
        var callback =
            callback && $.isFunction(callback) ? callback : function () {};
        var _default_settings = {
            cssClass: "ih-modal-flash",
            message:
                '<span class="ih-icon-checkmark-circle ih-modal-flash-icon"></span> ' +
                message,
            autoClose: 2,
            buttons: {},
            closeButton: false,
            close: callback,
        };
        var _settings = $.extend(true, _default_settings, options);
        return new ih.modal(_settings);
    };

    // --------------------------------------------------------------------------------------------------------
    ih.modalFrame = function (src, callback, options) {
        var callback =
            callback && $.isFunction(callback) ? callback : function () {};
        var _default_settings = {
            cssClass: "ih-modal-frame",
            message: '<iframe src="' + src + '"></iframe>',
            buttons: {},
            closeButton: true,
            close: callback,
        };
        var _settings = $.extend(true, _default_settings, options);
        return new ih.modal(_settings);
    };

    // --------------------------------------------------------------------------------------------------------
    // A modal form
    ih.modalForm = function (message, callback, options) {
        //console.log("ModalForm definition: ", options);

        var callback =
            callback && $.isFunction(callback) ? callback : function () {};
        var beforeCallback =
            options && options.beforeClose && $.isFunction(options.beforeClose)
                ? options.beforeClose
                : function () {
                      return true;
                  };

        // use form option as-is if provided
        var form = options && options.form ? options.form : {};

        // or else we'll look for the form options mixed in with the normal ones
        if (options && (!options.form || (options.form && options.fields))) {
            if (options.name) {
                form.name = options.name;
                delete options.name;
            }
            if (options.action) {
                form.action = options.action;
                delete options.action;
            }
            if (options.method) {
                form.method = options.method;
                delete options.method;
            }
            if (options.fields) {
                form.fields = options.fields;
                delete options.fields;
            }
            if (options.submit && $.isFunction(options.submit)) {
                form.submit = options.submit;
                delete options.submit;
            }
            if (options.success && $.isFunction(options.success)) {
                form.success = options.success;
                delete options.success;
            }
            if (options.failure && $.isFunction(options.failure)) {
                form.failure = options.failure;
                delete options.failure;
            }
        }

        var submit =
            form.submit && $.isFunction(form.submit)
                ? form.submit
                : beforeCallback;

        // add our Invisible Captcha block
        if (options.use_captcha) {
            //  data-callback="callback"
            //  data-sitekey="' + ih.data.recaptcha.invisiblePublicKey + '"
            // we will define the callback when we render the recaptcha
            //     html: '<div class="g-recaptcha g-re-invisible-captcha-placeholder" data-sitekey="' + ih.data.recaptcha.invisiblePublicKey + '"data-badge="inline" data-size="invisible"></div>',
            if (form && form.fields && Array.isArray(form.fields)) {
                form.fields.push({
                    html:
                        '<div class="field captcha-field recaptcha_field"><div id="simple_reg_recaptcha" class="g-recaptcha g-re-invisible-captcha-placeholder " data-badge="inline" data-size="invisible"></div></div>',
                    type: "recaptcha",
                });
                form.fields.push({
                    type: "hidden",
                    name: "invisible_captcha_enabled",
                    value: true,
                });
            }
        }

        var _default_settings = {
            //cssClass: "ih-modal-page",
            message: message,
            form: form,
            buttons: {
                cancel: {
                    label: "Cancel",
                    cssClass: "ih-modal-button-cancel",
                    callback: function () {
                        callback(false);
                    },
                    beforeCallback: function () {
                        return beforeCallback(false);
                    },
                },
                confirm: {
                    label: "OK",
                    cssClass: "ih-modal-button-primary",
                    callback: function (value, form) {
                        callback(value, form);
                    },
                    data: {},
                    //, beforeCallback: function(params, form) { return submit(params, form) }
                },
            },
            cancelButton: true,
            confirmButton: true,
            closeButton: true,
            close: function () {
                callback(false);
            },
            closeButtonConfirm: true,
        };

        var _settings = $.extend(true, _default_settings, options);

        if (!_settings.cancelButton) {
            delete _settings.buttons.cancel;
        }

        if (!_settings.confirmButton) {
            delete _settings.buttons.confirm;
        }

        _settings.beforeClose = function () {
            return beforeCallback(false);
        };

        return new ih.modal(_settings);
    }; // end modalForm

    // --------------------------------------------------------------------------------------------------------
    // Special modal form that prompts for an answer
    ih.prompt = function (message, callback, options) {
        var callback =
            callback && $.isFunction(callback) ? callback : function () {};
        var _default_settings = {
            message: message,
            form: {
                fields: [{ type: "text", required: true }],
            },
        };
        var _settings = $.extend(true, _default_settings, options);

        //console.log("settings", _settings);

        return new ih.modalForm(message, callback, _settings);
    };

    // --------------------------------------------------------------------------------------------------------
    //
    ih.simple = function (message, callback, options) {
        var callback =
            callback && $.isFunction(callback) ? callback : function () {};
        var _default_settings = {
            cssClass: "ih-simple-modal",
            message: message,
            buttons: {},
            closeButton: false,
            clickOutToClose: true,
            close: callback,
        };
        var _settings = $.extend(true, _default_settings, options);
        return new ih.modal(_settings);
    };

    // --------------------------------------------------------------------------------------------------------
    //
    ih.feature = function (message, callback, options) {
        var callback =
            callback && $.isFunction(callback) ? callback : function () {};
        var _default_settings = {
            cssClass: "ih-feature-discovery-modal",
            message: message,
            mask: false,
            buttons: {},
            closeButton: false,
            clickOutToClose: true,
            close: function () {
                callback(false);
            },
            tapTargetCallback: function () {
                callback(true);
            },
        };
        var _settings = $.extend(true, _default_settings, options);

        if (_settings.tapTarget == undefined) {
            console.error("ih.feature needs to have a tapTarget");
            return false;
        }

        return new ih.modal(_settings);
    };

    // TODO: hook this up to a CDN version...
    ih.data.svgHref = "/svg/materialdesign/symbol-defs.svg";

    // --------------------------------------------------------------------------------------------------------
    // Defines and runs really simple modal dialog box
    ih.simpleDialog = function (list, callback, options) {
        options = $.extend(
            {
                selectedValue: "",
            },
            options
        );

        var $optionsList = $("<ul>").addClass("modal-select-list");

        $.each(list, function (value, label) {
            var $li = $("<li>").appendTo($optionsList);

            if ("-" == label) {
                $li.addClass("divider");

                return;
            }

            var $a = $('<a href="#"></a>').data("value", value).appendTo($li);
            var iconClassName = "radio";

            if (value === options.selectedValue) {
                $li.addClass("selected");
                iconClassName = "radio-checked";
            }

            $(
                '<svg class="icon icon-' +
                    iconClassName +
                    '"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="' +
                    ih.data.svgHref +
                    "#icon-" +
                    iconClassName +
                    '"></use></svg>'
            ).appendTo($a);
            $("<span>" + label + "</span>")
                .addClass("primary-text")
                .appendTo($a);
        });

        // if there is an open callback in options it should ADD
        // to the default open callback, not replace it
        var openCallback = false;
        if (options !== undefined && options.open !== undefined) {
            openCallback = options.open;
            delete options.open;
        }

        var _default_settings = {
            cssClass: "ih-simple-modal",
            message: $optionsList,
            closeButton: false,
            clickOutToClose: true,
            open: function () {
                $(".ih-simple-modal").on("click", "a", function (e) {
                    e.preventDefault();
                    callback && callback($(this).data("value"), $(this).text());
                    _this.close();
                });

                if (openCallback) {
                    openCallback();
                }
            },
        };

        var _this = new ih.modal($.extend(true, _default_settings, options));

        return _this;
    }; // end simpleDialog

    var templates = {
        modal:
            "<div class='ih-modal' tabindex='-1' role='dialog'>" +
            "<div class='ih-modal-dialog'>" +
            "<div class='ih-modal-content'>" +
            "<div class='ih-modal-body'>" +
            "<div class='ih-modal-message'></div>" +
            "</div>" +
            "</div>" +
            "</div>" +
            "</div>",
        tapTarget:
            "<div class='ih-modal-tap-target-placeholder'>" +
            "<div class='ih-modal-tap-target-centerpoint'>" +
            "<div class='ih-modal-tap-target-circle-outer'></div>" +
            "</div>" +
            "<div class='ih-modal-tap-target-centerpoint'>" +
            "<div class='ih-modal-tap-target-circle-inner ih-anim-tap-target-pulsate infinite'></div>" +
            "</div>" +
            "<div class='ih-modal-tap-target-helper'></div>" +
            "<div class='ih-modal-tap-target-centerpoint'>" +
            "<div class='ih-modal-tap-target'></div>" +
            "</div>" +
            "</div>",
        header:
            "<div class='ih-modal-header'>" +
            "<h4 class='ih-modal-title'></h4>" +
            "</div>",
        footer: "<div class='ih-modal-footer'></div>",
        button:
            "<button type='button' class='ih-modal-button'><span></span></button>",
        closeButton:
            "<button type='button' class='ih-modal-close-x' aria-hidden='true' tabindex='-1'>&times;</button>",
        mask: "<div class='ih-modal-mask'></div>",
    };
})(jQuery);
